import * as React from "react";

export const ErrorIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
}> = ({ className, size = 24, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    className={className}
    color={color}
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      rx="11"
      stroke="#FF5247"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14L13 6ZM13 17.75C13 17.1977 12.5523 16.75 12 16.75C11.4477 16.75 11 17.1977 11 17.75V18.75C11 19.3023 11.4477 19.75 12 19.75C12.5523 19.75 13 19.3023 13 18.75V17.75Z"
      fill="#FF5247"
    />
  </svg>
);
